export const Relation = `
^XA

^FX 49mm x 20mm label
^FO10,30^AF,60
^FB100,1000,0,L,0
^FDAAM^FS
^FO270,2
^BQ,2,3,Q,7
^FDQA,{{BRANCH_CODE}};{{ORG_ID}};{{CUSTOMER_ID_REF}};{{CUSTOMER_ID}};{{CUSTOMER_NAME}}^FS

^CF0,15

^FX Branch Info (52 characters at max)
^FO5,125
^FB382,1000,0,L,0
^FD{{CUSTOMER_ID_REF}}-{{CUSTOMER_NAME}}^FS

^FX Branch Location
^FO5,140
^FB382,1000,0,L,0
^FD{{BRANCH_CODE}}^FS

^XZ
`;

export const Relation5x4 = `
^XA

^FX 49mm x 39mm label
^FO20,20^AF,40
^FB100,1000,0,L,0
^FDAAM^FS

^FX QR code
^FO135,10
^BQ,2,5,Q,7
^FDQA,{{BRANCH_CODE}};{{ORG_ID}};{{CUSTOMER_ID_REF}};{{CUSTOMER_ID}};{{CUSTOMER_NAME}}^FS

^CF0,15

^FX Branch Info (50 characters at max)
^FO20,260
^FB382,1000,0,L,0
^FD{{CUSTOMER_ID_REF}}-{{CUSTOMER_NAME}}^FS

^FX Branch Location
^FO20,280
^FB382,1000,0,L,0
^FD{{BRANCH_CODE}}^FS

^XZ
`;

export const Relation5x4AAMLogo = `
^XA

^FX 49mm x 39mm label
^FO15,85^AF,40
^FB100,1000,0,L,0

^FX AAM logo (110x73 px)
^FD
^GFA,1022,1022,14,Y038,X01F8,T07E007F8,S01FE00FF8,S07FE03FF8,S0FFE03FF8,R01FFE07FF8,P0701FFE07FF8,O01F03FFE0IF8,O07F03FFE0IF8,O0FF07FFE1IF8,N01FF07FFE1IF8,L0E03FF07FFE1IF8,K03E03FF0IFE3IF8,K07E07FF0IFE3IF8,K0FE07FF1IFE7IF8,J01FE07FF1IFE7IF8,J03FE0IF3FEFE7IF8,J07FE0IF3FDFEJF8,J07FE1IF3FDFEJF8,J0FFE1IF7FDJF7F8,I01FFE3FBF7F9IFEFF8,I01FFE3F3IF9IFEFF8,I03F7E7F3IF1IFC7F8,I07F7E7E3IF1IFCFF8,I07E7EFE3FFE1IFCFF8,I0FC7EKFE1IF8FF8,001FC7LFE1IF8FF8,001OFC1IF0FF8,003OFC1IF0FF8,007OF81IF0FF8,007KF07FF81FFE0FF8,00FF07FE03FF01FFC0FF8,01FE07FE03FF01FFC0FF8I0IFC03FC07FC03FE01FF807F83KF803F807FC03FE01FE007NF807E007F803FE01F800OF8078003F003FC01C01PF,U01QF,T01QFE,S01RFC,S0SFC,R07SF8,Q03SFE,Q0TF8,P07NFE,O01MF,O07KF8,N03KF,N0KF,M01JF,M07IF,L01IF8,L07FFC,L0FFE,K03FF8,K07FC,J01FF,J03FC,J07E,I01F8,I03E,I0F8,001E,003C,007,00C,03,06,08,1,,:^FS
^FS

^FX QR code
^FO160,30
^BQ,2,5,Q,7
^FDQA,{{BRANCH_CODE}};{{ORG_ID}};{{CUSTOMER_ID_REF}};{{CUSTOMER_ID}};{{CUSTOMER_NAME}}^FS

^CF0,15

^FX Branch Info (50 characters at max)
^FO1,260^A0,16
^FB500,2,0,L,0
^FD{{CUSTOMER_ID_REF}}-{{CUSTOMER_NAME}}^FS

^FX Branch Location
^FO0,280^A0,17
^FB382,1,0,L,0
^FD{{BRANCH_CODE}}^FS

^FX Argon Group Website
^FO270,300^AA,1
^FB382,1000,0,L,0
^FDwww.argon-group.com^FS

^XZ
`;
